const config = {
  NAME: 'Notificaciones',
  PATH: '/notificaciones',
};

export default config;
